
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as TeacherIconComponent } from "./teacher-icon.svg";

export const TeacherIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <TeacherIconComponent {...props} />;
};
